<div *ngIf="item">
  <lhc-autocomplete
    [options]="options"
    [item]="item"
    [(dataModel)]="item.value"
    (onBlurFn)="lhcDataService.activeRowOnBlur(item)"
    (onFocusFn)="lhcDataService.setActiveRow(item)"
    [isFormReady]="lhcDataService.isFormReady()"
    (dataModelChange)="addOrRemoveSubGroups()"
  ></lhc-autocomplete>
</div>
